module.exports = __webpack_public_path__ + "img/time_icon.c82016a8.svg";